import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { DownloadFileProps } from 'shared/services/contract-service';

export function useDownloadPdfFiles() {
  const { enqueueSnackbar } = useSnackbar();
  const { contractService } = useService();
  const mutation = useMutation<void, Error, DownloadFileProps>(
    request => contractService.downloadContractFile(request),
    {
      onError: error => {
        enqueueSnackbar('Could not find file for download', { variant: 'error' });
        console.log('File not downloaded ', error);
      },
    }
  );

  return mutation;
}

export function useDownloadQuotePdfFiles() {
  const { enqueueSnackbar } = useSnackbar();
  const { quoteService } = useService();
  const mutation = useMutation<void, Error, DownloadFileProps>(request => quoteService.downloadQuoteFile(request), {
    onError: error => {
      enqueueSnackbar('Could not find file for download', { variant: 'error' });
      console.log('File not downloaded ', error);
    },
  });

  return mutation;
}
